export default "__VITE_ASSET__CWzQJ19h__"